import * as R from 'ramda';
import FlagType from 'utils/ts/FlagType';

const getFlags: (object) => FlagType[] = R.pathOr([], ['user', 'data', 'flags']);

export default getFlags;

